import type { TenantChoice } from '@turnpilot/contracts';
import { type FormEvent, useState } from 'react';
import { login } from './api.ts';

const ERRORS: Record<string, string> = {
  invalid_credentials: 'Identifiants incorrects.',
  invalid_request: 'Saisie incomplète.',
  no_membership: 'Aucun accès actif pour ce compte.',
  totp_enrollment_required: 'La double authentification doit être activée pour ce rôle.',
  http_429: 'Trop de tentatives : réessayez dans une minute.',
};

/** Connexion (docs/04 §4) : e-mail + mot de passe, puis code TOTP ou choix du locataire si nécessaire. */
export function Login({ onDone }: { onDone: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [totp, setTotp] = useState('');
  const [needTotp, setNeedTotp] = useState(false);
  const [tenants, setTenants] = useState<TenantChoice[] | null>(null);
  const [tenant, setTenant] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    const r = await login({ email, password, ...(needTotp ? { totp } : {}), ...(tenant ? { tenant } : {}) });
    setBusy(false);
    if (r.step === 'done') onDone();
    else if (r.step === 'totp_required') setNeedTotp(true);
    else if (r.step === 'choose_tenant') {
      setTenants(r.tenants);
      setTenant(r.tenants[0]?.code ?? '');
    } else setError(ERRORS[r.error] ?? 'Connexion impossible.');
  }

  return (
    <main className="tp-login">
      <h1>Turnpilot</h1>
      <form onSubmit={submit} aria-label="Connexion">
        <label>
          E-mail
          <input
            type="email"
            name="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label>
          Mot de passe
          <input
            type="password"
            name="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {tenants && (
          <label>
            Locataire
            <select name="tenant" value={tenant} onChange={(e) => setTenant(e.target.value)}>
              {tenants.map((t) => (
                <option key={t.code} value={t.code}>
                  {t.name}
                </option>
              ))}
            </select>
          </label>
        )}
        {needTotp && (
          <label>
            Code de vérification
            <input
              name="totp"
              inputMode="numeric"
              autoComplete="one-time-code"
              pattern="\d{6}"
              required
              value={totp}
              onChange={(e) => setTotp(e.target.value)}
            />
          </label>
        )}
        {error && <p role="alert">{error}</p>}
        <button type="submit" disabled={busy}>
          Se connecter
        </button>
      </form>
    </main>
  );
}
